import { Fragment, useState } from "react";
import { useLocation } from "react-router";
import { FILTER_VIEW_APPLIED_STATE_KEY } from "../../configs/filterViews.config";

const readAppliedAt = (state: unknown): number | null => {
  if (typeof state !== "object" || state === null) return null;
  const appliedAt = (state as Record<string, unknown>)[FILTER_VIEW_APPLIED_STATE_KEY];
  return typeof appliedAt === "number" ? appliedAt : null;
};

/**
 * Remounts a list page when a saved view is applied: the pages read their
 * filters from the URL once, on mount. The key only moves forward, so the page
 * rewriting its URL afterwards (which drops the router state) does not remount
 * it a second time.
 */
const RemountOnFilterView = ({ children }: { children: React.ReactNode }) => {
  const appliedAt = readAppliedAt(useLocation().state);
  const [mountKey, setMountKey] = useState(appliedAt ?? 0);
  if (appliedAt !== null && appliedAt !== mountKey) setMountKey(appliedAt);

  return <Fragment key={mountKey}>{children}</Fragment>;
};

export default RemountOnFilterView;
